import React, { useState } from 'react';
import { Header } from '../Header';
import { Footer } from '../Footer';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Here you would typically send the form data to a server
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setFormData({
      name: '',
      email: '',
      message: ''
    });
  };
  return <div className="w-full bg-white" data-id="element-329">
      <Header data-id="element-330" />
      <main className="pt-28 pb-16 bg-white" data-id="element-331">
        <div className="container mx-auto px-4" data-id="element-332">
          <div className="max-w-2xl mx-auto" data-id="element-333">
            <h1 className="text-3xl font-bold text-amber-800 mb-8 text-center" data-id="element-334">
              Contacto
            </h1>
            {submitted ? <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center" data-id="element-335">
                <h2 className="text-xl font-bold text-green-700 mb-2" data-id="element-336">
                  ¡Mensaje Enviado!
                </h2>
                <p className="text-green-600" data-id="element-337">
                  Gracias por contactarnos. Responderemos a tu mensaje lo antes
                  posible.
                </p>
              </div> : <div className="bg-amber-50 rounded-xl p-8 border border-amber-100" data-id="element-338">
                <p className="text-gray-700 mb-6 text-center" data-id="element-339">
                  ¿Tienes alguna pregunta o comentario? Completa el formulario a
                  continuación y nos pondremos en contacto contigo lo antes
                  posible.
                </p>
                <form onSubmit={handleSubmit} className="space-y-6" data-id="element-340">
                  <div data-id="element-341">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-342">
                      Nombre completo
                    </label>
                    <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-343" />
                  </div>
                  <div data-id="element-344">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-345">
                      Correo electrónico
                    </label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-346" />
                  </div>
                  <div data-id="element-347">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-348">
                      Mensaje
                    </label>
                    <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={5} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-349"></textarea>
                  </div>
                  <div className="flex justify-center" data-id="element-350">
                    <button type="submit" className="bg-amber-600 hover:bg-amber-700 text-white font-bold py-3 px-8 rounded-lg shadow-md transition-colors" data-id="element-351">
                      Enviar mensaje
                    </button>
                  </div>
                </form>
              </div>}
          </div>
        </div>
      </main>
      <Footer data-id="element-352" />
    </div>;
}